module.exports = __webpack_public_path__ + "static/pinterest-e641e18302a70462fa3e867c59932b8f.jpg";